import { AdminUser } from '@modules/manifera-core/resources/js/schema'
import { create } from 'zustand'

type AuthState = 'loading' | 'unauthenticated' | 'authenticated'

export const useAuthenticateStore = create<{
  user: AdminUser | undefined
  authState: AuthState
  login: (user?: AdminUser) => unknown
  logout: () => unknown
  forceSetAuthState: (state: AuthState) => unknown
}>((set) => ({
  user: undefined,
  authState: 'loading',
  login: (user) => {
    set({ user: user, authState: 'authenticated' })
  },
  logout: () => {
    set({ user: undefined, authState: 'unauthenticated' })
  },
  forceSetAuthState: (state: AuthState) => {
    set({ authState: state })
  }
}))
